import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, Label } from 'reactstrap';
import { AvFeedback, AvForm, AvGroup, AvInput, AvField } from 'availity-reactstrap-validation';
import { Translate, translate, ICrudGetAction, ICrudGetAllAction, ICrudPutAction } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IRootState } from 'app/shared/reducers';

import { IJobOrderOwner } from 'app/shared/model/job-order-owner.model';
import { getEntities as getJobOrderOwners } from 'app/entities/job-order-owner/job-order-owner.reducer';
import { getEntity, updateEntity, createEntity, reset } from './job-order.reducer';
import { IJobOrder } from 'app/shared/model/job-order.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';

export interface IJobOrderUpdateProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string }> {}

export const JobOrderUpdate = (props: IJobOrderUpdateProps) => {
  const [jobOrderOwnerId, setJobOrderOwnerId] = useState('0');

  const [isNew, setIsNew] = useState(!props.match.params || !props.match.params.id);

  const { jobOrderEntity, jobOrderOwners, loading, updating } = props;

  const handleClose = () => {
    props.history.push('/job-order');
  };

  useEffect(() => {
    if (isNew) {
      props.reset();
    } else {
      props.getEntity(props.match.params.id);
    }

    props.getJobOrderOwners();
  }, []);

  useEffect(() => {
    if (props.updateSuccess) {
      handleClose();
    }
  }, [props.updateSuccess]);

  const saveEntity = (event, errors, values) => {
    if (errors.length === 0) {
      const entity = {
        ...jobOrderEntity,
        ...values
      };

      if (isNew) {
        props.createEntity(entity);
      } else {
        props.updateEntity(entity);
      }
    }
  };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="ordersManagementApp.jobOrder.home.createOrEditLabel">
            <Translate contentKey="ordersManagementApp.jobOrder.home.createOrEditLabel">Create or edit a JobOrder</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <AvForm model={isNew ? {} : jobOrderEntity} onSubmit={saveEntity}>
              {!isNew ? (
                <AvGroup>
                  <Label for="job-order-id">
                    <Translate contentKey="global.field.id">ID</Translate>
                  </Label>
                  <AvInput id="job-order-id" type="text" className="form-control" name="id" required readOnly />
                </AvGroup>
              ) : null}
              <AvGroup>
                <Label id="jobOrderNameLabel" for="job-order-jobOrderName">
                  <Translate contentKey="ordersManagementApp.jobOrder.jobOrderName">Job Order Name</Translate>
                </Label>
                <AvField
                  id="job-order-jobOrderName"
                  type="text"
                  name="jobOrderName"
                  validate={{
                    required: { value: true, errorMessage: translate('entity.validation.required') }
                  }}
                />
              </AvGroup>
              <AvGroup>
                <Label id="jobOrderCodeLabel" for="job-order-jobOrderCode">
                  <Translate contentKey="ordersManagementApp.jobOrder.jobOrderCode">Job Order Code</Translate>
                </Label>
                <AvField
                  id="job-order-jobOrderCode"
                  type="text"
                  name="jobOrderCode"
                  validate={{
                    required: { value: true, errorMessage: translate('entity.validation.required') }
                  }}
                />
              </AvGroup>
              <AvGroup>
                <Label id="startDateLabel" for="job-order-startDate">
                  <Translate contentKey="ordersManagementApp.jobOrder.startDate">Start Date</Translate>
                </Label>
                <AvField id="job-order-startDate" type="date" className="form-control" name="startDate" />
              </AvGroup>
              <AvGroup>
                <Label id="endDateLabel" for="job-order-endDate">
                  <Translate contentKey="ordersManagementApp.jobOrder.endDate">End Date</Translate>
                </Label>
                <AvField id="job-order-endDate" type="date" className="form-control" name="endDate" />
              </AvGroup>
              <AvGroup>
                <Label for="job-order-jobOrderOwner">
                  <Translate contentKey="ordersManagementApp.jobOrder.jobOrderOwner">Job Order Owner</Translate>
                </Label>
                <AvInput id="job-order-jobOrderOwner" type="select" className="form-control" name="jobOrderOwner.id">
                  <option value="" key="0" />
                  {jobOrderOwners
                    ? jobOrderOwners.map(otherEntity => (
                        <option value={otherEntity.id} key={otherEntity.id}>
                          {otherEntity.name}  {otherEntity.surname}
                        </option>
                      ))
                    : null}
                </AvInput>
              </AvGroup>
          
              <Button tag={Link} id="cancel-save" to="/job-order" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </AvForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = (storeState: IRootState) => ({
  jobOrderOwners: storeState.jobOrderOwner.entities,
  jobOrderEntity: storeState.jobOrder.entity,
  loading: storeState.jobOrder.loading,
  updating: storeState.jobOrder.updating,
  updateSuccess: storeState.jobOrder.updateSuccess
});

const mapDispatchToProps = {
  getJobOrderOwners,
  getEntity,
  updateEntity,
  createEntity,
  reset
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(JobOrderUpdate);
